export enum Role {
    OWNER = 'owner',
    MEMBER = 'member',
    BOOKKEEPER = 'bookkeeper',
}

export interface Employee {
    id: string
    role: Role
    userId: string
    firstName: string
    lastName: string
    email: string
}
